var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraphglPreview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 182,
    viewBox: "0 0 200 182",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 120.949,
    cy: 39.6984,
    r: 28.1252,
    transform: "rotate(-48.5555 120.949 39.6984)",
    fill: "#252C34"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 143.753,
    cy: 143.757,
    r: 31.2502,
    transform: "rotate(90 143.753 143.757)",
    fill: "#ADB5BD"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.4616,
    cy: 105.201,
    r: 31.2502,
    transform: "rotate(-120 67.4616 105.201)",
    fill: "#868E96"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.805,
    cy: 84.5591,
    r: 15.6251,
    transform: "rotate(-48.5555 140.805 84.5591)",
    fill: "#868E96"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.0542,
    cy: 47.0562,
    r: 15.6251,
    transform: "rotate(-48.5555 67.0542 47.0562)",
    fill: "#868E96"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 172.055,
    cy: 40.8091,
    r: 15.6251,
    transform: "rotate(-48.5555 172.055 40.8091)",
    fill: "#ADB5BD"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 181.253,
    cy: 112.506,
    rx: 12.5001,
    ry: 12.5001,
    transform: "rotate(90 181.253 112.506)",
    fill: "#252C34"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.6132,
    cy: 151.009,
    rx: 12.5001,
    ry: 12.5001,
    transform: "rotate(-120 50.6132 151.009)",
    fill: "#868E96"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 187.5,
    cy: 168.762,
    rx: 12.5001,
    ry: 12.5001,
    transform: "rotate(90 187.5 168.762)",
    fill: "#ADB5BD"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.0753,
    cy: 105.418,
    rx: 12.5001,
    ry: 12.5001,
    transform: "rotate(-120 17.0753 105.418)",
    fill: "#252C34"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.0749,
    cy: 62.0785,
    rx: 12.5001,
    ry: 12.5001,
    transform: "rotate(-120 37.0749 62.0785)",
    fill: "#252C34"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.0749,
    cy: 22.0767,
    rx: 12.5001,
    ry: 12.5001,
    transform: "rotate(-120 37.0749 22.0767)",
    fill: "#ADB5BD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphglPreview);
export default __webpack_public_path__ + "static/media/graphglPreview.300919f85d0f26b636a9a129abdcb8df.svg";
export { ForwardRef as ReactComponent };